import { useEffect, useState } from 'react';
import { apiGet } from '../api/readerApi';

const CACHE_KEY = 'jeshua_plans';

const readCache = () => {
  try {
    const raw = window.sessionStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const writeCache = (plans) => {
  try {
    window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(plans));
  } catch (error) { /* storage unavailable */ }
};

let plansInMemory = readCache();
let pending = null;

const loadPlans = () => {
  if (plansInMemory) return Promise.resolve(plansInMemory);
  if (!pending) {
    pending = apiGet('/plans')
      .then((result) => {
        if (!result.ok || !result.data || !Array.isArray(result.data.plans)) return [];
        plansInMemory = [...result.data.plans].sort((a, b) => a.order - b.order);
        writeCache(plansInMemory);
        return plansInMemory;
      })
      .finally(() => { pending = null; });
  }
  return pending;
};

export const usePlans = () => {
  const [plans, setPlans] = useState(plansInMemory || []);

  useEffect(() => {
    let alive = true;
    loadPlans().then((loaded) => { if (alive) setPlans(loaded); });
    return () => { alive = false; };
  }, []);

  return plans;
};
